import {
	ChangeDetectionStrategy,
	Component
} from '@angular/core';

@Component({
	selector: 'tool-unavailable-error',
	templateUrl: './tool-unavailable-error.component.html',
	styleUrls: ['./tool-unavailable-error.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class ToolUnavailableErrorComponent {
	constructor () {}
}
